import { render, staticRenderFns } from "./TeamField.vue?vue&type=template&id=634871a1&"
import script from "./TeamField.vue?vue&type=script&lang=js&"
export * from "./TeamField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports